<template>
	<div>
		<div v-if="slotNodeLength > limitMoreButtons">
			<div class="detail-bill-return f-right detail-bill-white" :class="{'active': extraBtnsShow}" @click.stop="extraBtnsShow = !extraBtnsShow">更多</div>
			<transition name='slide-open-up'>
				<div class="edi-extra-btn-container" v-show="extraBtnsShow" @click="hideExtraBtns">
					<slot name="buttons"></slot>
				</div>
			</transition>
		</div>
		<div v-else>
			<slot name="buttons"></slot>
		</div>
	</div>
</template>
<script>
	export default {
		props: {
			limitMoreButtons: {
				type: Number,
				default: 1
			}
		},
		data () {
			return {
				extraBtnsShow: false
			}
		},
		computed: {
			slotNodeLength () {
				let buttonNodes = this.$slots['buttons']
				// console.log(buttonNodes)
				if (buttonNodes) {
					let filterNodes = buttonNodes.filter(item => item.tag)
					return filterNodes.length
				} else {
					return 0
				}
			}
		},
		methods: {
			hideExtraBtns () {
				this.extraBtnsShow = false
			}
		}
	}
</script>


// WEBPACK FOOTER //
// MoreButtons.vue?a2e696da